//@flow

import React, { Component } from 'react';
import { parse } from 'query-string';
import capitalize from 'lodash/capitalize';
import { connect } from 'react-redux';

import api from '../../lib/api';
import TravelStyle from './TravelStyle';
import TravelDetail from './TravelDetail';
import CreateAccount from './CreateAccount';
import { decamelizeKeys } from 'humps';
import { registerAccount } from '../../redux/actions/authActions';
import OnboardingFormReducer from './reducer';
import UserInformationBuilder from './OnboardingDataBuilder';
import getNextMonthsWithYears, { validate, activeClassNameFor } from './helpers';

type Props = {
  serverError: string,
  loading: boolean,
  registerAccount: Function,
  isUserLoggedIn: boolean,
};

type State = {
  step: number,
  groupSize: number,
  month: string,
  dateRange: null | Array<String>,
  interestedRegions: null | Array<String>,
  trekType: null | string,
  services: null | Array<String>,
  selectedDateCondition: null | string,
};

const Headers = ['Travel Style', 'Travel Detail', 'Create Account'];

class OnboardingForm extends Component<Props, State> {
  state = {
    step: 1,
    groupSize: 1,
    duration: 1,
    month: getNextMonthsWithYears(1)[0],
    dateRange: null,
    interestedRegions: this.parseInterestedRegion(),
    trekType: null,
    services: null,
    selectedDateCondition: null,
  };

  parseInterestedRegion() {
    const region = parse(this.props.location.search).region;

    return region ? [capitalize(region)] : null;
  }

  dispatch = action => this.setState(OnboardingFormReducer(this.state, action));

  choosePresentStep = () => {
    const {
      step,
      groupSize,
      duration,
      month,
      dateRange,
      trekType,
      services,
      interestedRegions,
      selectedDateCondition,
    } = this.state;
    const { isUserLoggedIn, location } = this.props;
    const disabled = validate(this.state, this.props);
    const dateAlreadySelected = parse(location.search).start_date;

    if (step === 1)
      return (
        <TravelStyle
          month={month}
          duration={duration}
          dispatch={this.dispatch}
          groupSize={groupSize}
          dateRange={dateRange}
          disabled={disabled}
          userHasStartDate={Boolean(dateAlreadySelected)}
          selectedDateCondition={selectedDateCondition}
        />
      );

    if (step === 2)
      return (
        <TravelDetail
          trekType={trekType}
          services={services}
          dispatch={this.dispatch}
          disabled={disabled}
          interestedRegions={interestedRegions}
        />
      );

    if (step === 3) {
      return (
        <CreateAccount
          {...this.props}
          dispatch={this.dispatch}
          isUserLoggedIn={isUserLoggedIn}
          sendInfoToBackend={this.sendToApi}
        />
      );
    }
  };

  sendToApi = async () => {
    const apiData = new UserInformationBuilder(this.state)
      .travelStyle()
      .travelDetail()
      .build();

    try {
      await api.post('users/onboard', decamelizeKeys(apiData));
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    const { step } = this.state;
    return (
      <div className="onboarding-darkbox">
        <div className="onboarding-form">
          <div className="white-panel">
            <ul className="onboarding-form-breadcrumb">
              {Headers.map((header, idx) => (
                <li key={header} className={activeClassNameFor(idx + 1, step)}>
                  <span className="mobile-step">{idx + 1}</span>
                  <span>{header}</span>
                </li>
              ))}
            </ul>
            <div className="row py-5">
              <div className="col-lg-2 col-12" />
              <div className="col-lg-8 col-12">{this.choosePresentStep()}</div>
              <div className="col-lg-2 col-12" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({ user }) => ({
    serverError: user.error,
    loading: user.isFetching,
    isUserLoggedIn: Boolean(user.userId),
  }),
  { registerAccount }
)(OnboardingForm);



// WEBPACK FOOTER //
// ./src/screens/OnboardingForm/OnboardingForm.jsx